<template>
  <ValidationObserver ref="observer" tag="form" @submit.prevent="submit">
    <v-card flat>
      <div class="flex flex-wrap my-2 mx-6 mb-4">
        <div class="w-full md:w-1/2 px-3 mb-6 required">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Organization Name</label>
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field v-model="formValues.name" outlined dense hide-details="auto" />
            <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 required">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Organization Type</label>
          <validation-provider v-slot="{ errors }" rules="required">
            <v-combobox
                v-model="formValues.type"
                :items="typeOptions"
                outlined
                dense
                hide-details="auto"
                placeholder="Select or enter a type"
            />
            <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" depressed class="white--text" @click="submit">
          {{ formValues.editMode ? "Update" : "Add" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", {...required, message: "This field is required"});

export default {
  components: {ValidationObserver, ValidationProvider},
  props: {organization: Object},
  data() {
    return {
      formValues: {name: "", type: "", editMode: false},
      typeOptions: ["Donor", "Government", "NGO", "Private", "Institution"],
    };
  },
  created() {
    if (this.organization) {
      this.formValues = {...this.organization, editMode: true};
    }
  },
  methods: {
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$emit("save", {...this.formValues});
    },
  },
};
</script>

<style scoped>
.required > label::after { content: "*"; color: red; padding-left: 3px; }
</style>
